import { render, staticRenderFns } from "./PrivateReviewSimulations.vue?vue&type=template&id=e751ac28&scoped=true"
import script from "./PrivateReviewSimulations.vue?vue&type=script&lang=js"
export * from "./PrivateReviewSimulations.vue?vue&type=script&lang=js"
import style0 from "./PrivateReviewSimulations.vue?vue&type=style&index=0&id=e751ac28&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e751ac28",
  null
  
)

export default component.exports